<script>
  import Tailwind from './Tailwind.svelte'
  import Departures from './Departures.svelte'
  import Message from './Message.svelte'
  import Clock from './Clock.svelte'
  import Logo from "./Logo.svelte";

  let error = undefined
  let wantedStation = undefined

  try {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    let stopString = urlParams.get('station') ? urlParams.get('station').toUpperCase() : null;
    wantedStation = stopString || 'BRUSSELS-CENTRAL';
    console.log("The requested station is: " + wantedStation);
  } catch (e) {
    console.log(e)
  }
</script>

<Tailwind />

<div class="bg-black text-white h-screen w-screen overflow-hidden">
  <div class="grid grid-cols-frame grid-rows-frame h-full w-full">
    <div class="row-span-full col-start-1 col-end-2 bg-primary" />
    <div
      class="row-start-2 row-end-3 col-span-full bg-primary px-6 flex justify-between items-center"
    >
      <Logo />
    </div>
    <div
      class="col-start-2 col-end-3 row-start-1 row-end-2 overflow-hidden px-2 pb-2"
    >
      {#if wantedStation && !error}
        <div
          class="bg-black flex flex-row h-full w-full space-x-2 overflow-hidden"
        >
          <Departures wantedStation="{wantedStation}" />
        </div>
      {:else}
        <Message
          title="Something went wrong!"
          text="We encountered an issue."
        />
      {/if}
    </div>
  </div>
</div>
